import styled, { css } from 'styled-components';
import { mq } from '../../styles/grid';
import getGutter from '../helpers/getGutter/getGutter';

/**
 * @param {number | undefined} [amount]
 * @param {boolean | undefined} [isJobSearch]
 * @returns {string}
 */
export const getColWidth = (amount, isJobSearch) => {
  let colsAmount;
  switch (amount) {
    case undefined:
      colsAmount = 12;
      break;
    case 0:
      colsAmount = 0;
      break;
    default:
      colsAmount = amount;
  }
  const colsMaxAmount = 12;
  return `${(colsAmount / colsMaxAmount) * 99.99 - (isJobSearch ? 1 : 0)}%`;
};

const ColStyled = styled.div`
  margin: ${(props) => props.$gutter / 2}px;
  margin-left: ${(props) =>
    props.$offsetCol.xl !== '0%'
      ? props.$offsetCol.xl
      : `${props.$gutter / 2}px`};
  width: calc(
    ${(props) => props.$colAmount.xl} - ${(props) => props.$gutter}px
  );

  @media (${mq.lgDown}) {
    margin-left: ${(props) =>
      props.$offsetCol.lg !== '0%'
        ? props.$offsetCol.lg
        : `${props.$gutter / 2}px`};
    width: calc(
      ${(props) => props.$colAmount.lg} - ${(props) => props.$gutter}px
    );
  }

  @media (${mq.mdDown}) {
    margin-left: ${(props) =>
      props.$offsetCol.md !== '0%'
        ? props.$offsetCol.md
        : `${props.$gutter / 2}px`};
    width: calc(
      ${(props) => props.$colAmount.md} - ${(props) => props.$gutter}px
    );
  }

  @media (${mq.smDown}) {
    ${(props) =>
      props.$enlargeBottom !== undefined &&
      css`
        margin-bottom: ${props.$gutter}px;
      `}

    margin-left: ${(props) =>
      props.$offsetCol.sm !== '0%'
        ? props.$offsetCol.sm
        : `${props.$gutter / 2}px`};
    width: calc(
      ${(props) => props.$colAmount.sm} - ${(props) => props.$gutter}px
    );
  }

  @media (${mq.xs}) {
    margin-left: ${(props) =>
      props.$offsetCol.sm !== '0%'
        ? props.$offsetCol.sm
        : `${props.$gutter / 2}px`};
    width: calc(
      ${(props) => props.$colAmount.xs} - ${(props) => props.$gutter}px
    );
  }
`;

const defaultAmount = { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 };

const defaultOffset = { xl: 0, lg: 0, md: 0, sm: 0, xs: 0 };

/**
 * @param {ColType} props
 * @returns {React.ReactElement} The rendered component
 */
const Col = ({
  className,
  colAmount = defaultAmount,
  children,
  offset = defaultOffset,
  gutter,
  enlargeBottom,
  isJobSearch,
  dataId,
}) => (
  <ColStyled
    className={className}
    $colAmount={{
      xl: getColWidth(colAmount.xl, isJobSearch),
      lg: getColWidth(colAmount.lg, isJobSearch),
      md: getColWidth(colAmount.md, isJobSearch),
      sm: getColWidth(colAmount.sm, isJobSearch),
      xs: getColWidth(colAmount.xs, isJobSearch),
    }}
    $offsetCol={{
      xl: getColWidth(offset.xl, isJobSearch),
      lg: getColWidth(offset.lg, isJobSearch),
      md: getColWidth(offset.md, isJobSearch),
      sm: getColWidth(offset.sm, isJobSearch),
      xs: getColWidth(offset.xs, isJobSearch),
    }}
    $gutter={getGutter(gutter, isJobSearch)}
    $enlargeBottom={enlargeBottom}
    data-id={dataId}
  >
    {children}
  </ColStyled>
);

export default Col;
